import OrderMixin from './OrderMixin'

export default {
    mixins: [
        OrderMixin
    ]
}